import { render, staticRenderFns } from "./AppLayoutPreliminaryAssessment.vue?vue&type=template&id=461cac4f&scoped=true&"
import script from "./AppLayoutPreliminaryAssessment.vue?vue&type=script&lang=js&"
export * from "./AppLayoutPreliminaryAssessment.vue?vue&type=script&lang=js&"
import style0 from "./AppLayoutPreliminaryAssessment.vue?vue&type=style&index=0&id=461cac4f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461cac4f",
  null
  
)

export default component.exports